import { BadgeDesign, badgeHeight, badgeSVG } from './badge-svg';

const OUTFIT_URL = 'https://fonts.googleapis.com/css2?family=Outfit:wght@600&display=swap';

const ensureOutfit = async () => {
  const { fonts } = document as Document & { fonts?: FontFaceSet };
  if (!fonts) return;
  if (!document.querySelector(`link[href="${OUTFIT_URL}"]`)) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = OUTFIT_URL;
    document.head.appendChild(link);
  }
  try {
    await fonts.load('600 18px Outfit');
  } catch (err) {
    // Falls back to system-ui
  }
};

const fontFaceCss = async () => {
  try {
    const css = await (await fetch(OUTFIT_URL)).text();
    const url = (css.match(/url\((https:[^)]+\.woff2)\)/) || [])[1];
    if (!url) return '';
    const blob = await (await fetch(url)).blob();
    const dataUrl = await new Promise<string>((resolve) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.readAsDataURL(blob);
    });
    return `<style>@font-face{font-family:Outfit;font-weight:600;src:url(${dataUrl}) format('woff2');}</style>`;
  } catch (err) {
    return '';
  }
};

const needsFont = (design: BadgeDesign) => design.centre === 'text' || (design.centre === 'number' && !!design.unit);

export const renderBadgePng = async (design: BadgeDesign, width = 256): Promise<Blob> => {
  let svg = badgeSVG(design, { size: width });
  if (needsFont(design)) {
    await ensureOutfit();
    const style = await fontFaceCss();
    if (style) svg = svg.replace('<defs>', `<defs>${style}`);
  }
  const height = Math.round((width * badgeHeight(design)) / 200);
  const scale = 2;
  const url = URL.createObjectURL(new Blob([svg], { type: 'image/svg+xml' }));
  try {
    const img = await new Promise<HTMLImageElement>((resolve, reject) => {
      const image = new Image();
      image.onload = () => resolve(image);
      image.onerror = reject;
      image.src = url;
    });
    const canvas = document.createElement('canvas');
    canvas.width = width * scale;
    canvas.height = height * scale;
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('Canvas unavailable');
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    return await new Promise<Blob>((resolve, reject) =>
      canvas.toBlob((blob) => (blob ? resolve(blob) : reject(new Error('PNG export failed'))), 'image/png')
    );
  } finally {
    URL.revokeObjectURL(url);
  }
};
